import DigitalPoC from './DigitalPoC'

export default DigitalPoC
